<template>
  <app-confirmation-modal v-bind="$attrs" @input="$emit('input', $event)" persistent max-width="500px">
    <template v-slot:title>{{ $t('WaterQualityGraphErrorModal.titleMsg') }}</template>
    <template v-slot:text>
      <v-layout row wrap>
        <v-flex xs12 pb-4>{{ descriptionMsg }}</v-flex>
        <v-flex xs12>
          <v-expansion-panel v-if="itemLength">
            <v-expansion-panel-content key="header" class="elevation-3">
              <template v-slot:header>
                <div>
                  {{ $t('WaterQualityGraphErrorModal.errorMessage', { msg: pluralize('Message', itemLength) }) }}
                  <v-chip>{{ itemLength }}</v-chip>
                </div>
              </template>
              <v-expansion-panel>
                <template v-if="isUnhandledException">
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <span>
                        {{ data.Message }}
                        <span v-if="data.ExceptionMessage">{{ data.ExceptionMessage }}</span>
                      </span>
                    </template>
                  </v-expansion-panel-content>
                </template>
                <template v-else>
                  <analyte-guideline-unit-mismatch-record-item v-if="hasAnalyteGuidelineUnitMismatchExceptionRecord" :itemData="data.AnalyteGuidelineUnitMismatchExceptionRecord.Errors"></analyte-guideline-unit-mismatch-record-item>              
                  <analyte-labResult-unit-mismatch-record-item v-if="hasAnalyteLabResultUnitMismatchExceptionRecord" :itemData="data.AnalyteLabResultUnitMismatchExceptionRecord.Errors"></analyte-labResult-unit-mismatch-record-item>
                </template>
              </v-expansion-panel>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-layout>
    </template>
    <template v-slot:actions>
      <v-spacer />
      <v-btn color="secondary" @click="_emitCancel">{{ $t('Button.Close') }}</v-btn>
    </template>
  </app-confirmation-modal>
</template>

<script>
  import AppConfirmationModal from '@/components/generic/AppConfirmationModal'
  import AnalyteLabResultUnitMismatchRecordItem from '@/components/generic/ErrorModalItem/AnalyteLabResultUnitMismatchRecordItem'
  import AnalyteGuidelineUnitMismatchRecordItem from '@/components/generic/ErrorModalItem/AnalyteGuidelineUnitMismatchRecordItem' 
  import {
    pluralize,
  } from '@/helpers/strings'
  export default {
    components: {
      'app-confirmation-modal': AppConfirmationModal,
      'analyte-labResult-unit-mismatch-record-item': AnalyteLabResultUnitMismatchRecordItem,
      'analyte-guideline-unit-mismatch-record-item': AnalyteGuidelineUnitMismatchRecordItem,
    },
    props: {
      data: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
      }
    },
    computed:{
      isUnhandledException() {
        return !this.hasAnalyteLabResultUnitMismatchExceptionRecord && !this.hasAnalyteGuidelineUnitMismatchExceptionRecord
      },
      hasAnalyteLabResultUnitMismatchExceptionRecord() {
        return !!this.data && !!this.data.AnalyteLabResultUnitMismatchExceptionRecord && this.data.AnalyteLabResultUnitMismatchExceptionRecord.HasErrors
      },
      hasAnalyteGuidelineUnitMismatchExceptionRecord() {
        return !!this.data && !!this.data.AnalyteGuidelineUnitMismatchExceptionRecord && this.data.AnalyteGuidelineUnitMismatchExceptionRecord.HasErrors
      },
      dataLength() {
        let AnalyteLabResultUnitMismatchExceptionRecordLength = this.hasAnalyteLabResultUnitMismatchExceptionRecord ? this.data.AnalyteLabResultUnitMismatchExceptionRecord.Errors.length : 0
        let AnalyteGuidelineUnitMismatchExceptionRecordLength = this.hasAnalyteGuidelineUnitMismatchExceptionRecord ? this.data.AnalyteGuidelineUnitMismatchExceptionRecord.Errors.length : 0
        return AnalyteLabResultUnitMismatchExceptionRecordLength + AnalyteGuidelineUnitMismatchExceptionRecordLength
      },
      itemLength() {
        return this.dataLength > 0 ? this.dataLength : 1
      },
      descriptionMsg() {
        if (this.hasAnalyteLabResultUnitMismatchExceptionRecord || this.hasAnalyteGuidelineUnitMismatchExceptionRecord) {
          if(this.hasAnalyteGuidelineUnitMismatchExceptionRecord && this.hasAnalyteLabResultUnitMismatchExceptionRecord) {
            return this.$t('WaterQualityGraphErrorModal.BothMsg', 
              {
                setttingPart: pluralize('setting', this.data.AnalyteGuidelineUnitMismatchExceptionRecord.Errors.length), 
                pointPart: pluralize('point', this.data.AnalyteLabResultUnitMismatchExceptionRecord.Errors.length),
              })          
          } else if (this.hasAnalyteLabResultUnitMismatchExceptionRecord) {
            return this.$t('WaterQualityGraphErrorModal.labResultUnitMismatchMsg', 
              {
                messagePart: pluralize('message', this.data.AnalyteLabResultUnitMismatchExceptionRecord.Errors.length), 
                pointPart: pluralize('point', this.data.AnalyteLabResultUnitMismatchExceptionRecord.Errors.length),
              })
          } else if (this.hasAnalyteGuidelineUnitMismatchExceptionRecord) {
            return this.$t('WaterQualityGraphErrorModal.analyteUnitMismatchMsg', 
              {
                messagePart: pluralize('message', this.data.AnalyteGuidelineUnitMismatchExceptionRecord.Errors.length), 
                setttingPart: pluralize('setting', this.data.AnalyteGuidelineUnitMismatchExceptionRecord.Errors.length),
              })
          } else {
            return ''
          }
        }
      },
    },
    methods: {
      pluralize,
      _emitCancel() {
        this.$emit('cancel')
      },
    },
    mounted() {},
  }
</script>